(function() {
  var EVENT_API = 'https://headline-proxy.vercel.app/api/cro-event';
  var CART_ATTRIBUTE = 'cro_site_experiments';
  var STORAGE_PREFIX = 'cro_exp_';
  var VALID_VARIANTS = { A: true, B: true };

  function normalizeExperimentId(value) {
    return String(value || '').trim();
  }

  function normalizeVariant(value) {
    value = String(value || '').trim().toUpperCase();
    return VALID_VARIANTS[value] ? value : '';
  }

  function storageKey(experimentId) {
    return STORAGE_PREFIX + experimentId;
  }

  function getAssignment(experimentId) {
    var key = storageKey(experimentId);
    var assigned = normalizeVariant(localStorage.getItem(key));

    if (!assigned) {
      assigned = Math.random() < 0.5 ? 'A' : 'B';
      localStorage.setItem(key, assigned);
    }

    return assigned;
  }

  function getSectionShell(section) {
    return section.closest('.shopify-section') || section;
  }

  function hideSection(section) {
    var shell = getSectionShell(section);
    shell.style.display = 'none';
    shell.setAttribute('data-cro-hidden', 'true');
  }

  function showSection(section) {
    var shell = getSectionShell(section);
    shell.style.display = '';
    shell.removeAttribute('data-cro-hidden');
  }

  function buildAssignmentsString(assignments) {
    return Object.keys(assignments)
      .sort()
      .map(function(experimentId) {
        return experimentId + ':' + assignments[experimentId];
      })
      .join('|');
  }

  function stampCart(assignments) {
    var value = buildAssignmentsString(assignments);
    if (!value) return;

    localStorage.setItem(CART_ATTRIBUTE, value);

    var attributes = {};
    attributes[CART_ATTRIBUTE] = value;

    var popupVariant = normalizeVariant(localStorage.getItem('cro_variant'));
    if (popupVariant) {
      attributes.cro_variant = popupVariant;
    }

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    }).catch(function() {});
  }

  function trackEvent(type, section) {
    var experimentId = normalizeExperimentId(section.getAttribute('data-cro-experiment-id'));
    var variant = normalizeVariant(section.getAttribute('data-cro-assigned-variant'));
    if (!experimentId || !variant) return;

    var payload = {
      type: type,
      experimentId: experimentId,
      variant: variant,
      sectionId: section.getAttribute('data-cro-section-id') || '',
      sectionType: section.getAttribute('data-cro-section-type') || '',
      path: window.location.pathname
    };

    if (navigator.sendBeacon) {
      var blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
      if (navigator.sendBeacon(EVENT_API, blob)) return;
    }

    fetch(EVENT_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true
    }).catch(function() {});
  }

  function trackImpressions(sections) {
    var seen = {};

    function markSeen(section) {
      var sectionId = section.getAttribute('data-cro-section-id') || '';
      var experimentId = section.getAttribute('data-cro-experiment-id') || '';
      var key = experimentId + ':' + sectionId;
      if (seen[key]) return;

      seen[key] = true;
      trackEvent('impression', section);
    }

    if (!('IntersectionObserver' in window)) {
      sections.forEach(markSeen);
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;

        observer.unobserve(entry.target);
        markSeen(entry.target);
      });
    }, { threshold: 0.35 });

    sections.forEach(function(section) {
      observer.observe(section);
    });
  }

  function trackClicks(sections) {
    sections.forEach(function(section) {
      section.addEventListener('click', function(event) {
        var target = event.target.closest('a, button, [role="button"], input[type="submit"]');
        if (!target || !section.contains(target)) return;

        trackEvent('click', section);
      });
    });
  }

  function init() {
    var candidates = Array.prototype.slice.call(document.querySelectorAll('[data-cro-experiment-id][data-cro-variant]'));
    var activeSections = [];
    var assignments = {};

    candidates.forEach(function(section) {
      var experimentId = normalizeExperimentId(section.getAttribute('data-cro-experiment-id'));
      var configuredVariant = normalizeVariant(section.getAttribute('data-cro-variant'));

      if (!experimentId || !configuredVariant) {
        showSection(section);
        return;
      }

      var assignedVariant = assignments[experimentId] || getAssignment(experimentId);
      assignments[experimentId] = assignedVariant;
      section.setAttribute('data-cro-assigned-variant', assignedVariant);

      if (configuredVariant === assignedVariant) {
        showSection(section);
        activeSections.push(section);
      } else {
        hideSection(section);
      }
    });

    stampCart(assignments);
    if (!activeSections.length) return;

    trackImpressions(activeSections);
    trackClicks(activeSections);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
